<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">贷款计算器</span>
    </navbar>
    <div class="page-content">
      <div class="container">
        <form method="post" novalidate="novalidate" @submit.prevent="calc">
          <div class="input-group">
            <div class="form-label">
              <label>贷款金额</label>
              <span class="required">*</span>
            </div>
            <div class="input-group-addon">
              <input type="text" class="form-control" maxlength="15" v-model="amount" @focus="amount = currency2number(amount)" @blur="amount = number2currency(amount)">
              <span class="help-text">元</span>
            </div>
          </div>
          <div class="input-group">
            <div class="form-label">
              <label>贷款期限</label>
              <span class="required">*</span>
            </div>
            <div class="input-group-addon">
              <input type="number" class="form-control loan-life-text" :value="loanLife" @change="setLoanLife" ref="loanLifeInp">
              <div class="loan-life">
                <div class="loan-life-item"><input type="radio" name="loanLife" :value="0" v-model="loanLifeType" checked="checked"><span>天</span></div>
                <div class="loan-life-item"><input type="radio" name="loanLife" :value="1" v-model="loanLifeType"><span>月</span></div>
              </div>
              <!--<span class="caret"></span>-->
            </div>
          </div>
          <div class="input-group">
            <div class="form-label">
              <label>起息日</label>
            </div>
            <div class="input-group-addon">
              <!--<input type="date" class="form-control" @input="setStartDay" ref="startDate">-->
              <input type="text" class="form-control" v-model="startDay" placeholder="起息日，选填">
              <div class="input-alias" @click="showStartDatePicker"></div>
              <datePicker
                :is-show="isShowStartDate"
                @select-date="setStartDay"/>
            </div>
          </div>
          <div class="input-group">
            <div class="form-label">
              <label>到期日</label>
            </div>
            <div class="input-group-addon">
              <!--<input type="date" class="form-control" @input="setEndDay" ref="endDate">-->
              <input type="text" class="form-control" v-model="endDay" placeholder="到期日，选填">
              <div class="input-alias" @click="showEndDatePicker"></div>
              <datePicker
                :is-show="isShowEndDate"
                @select-date="setEndDay"/>
            </div>
          </div>
          <div class="input-group">
            <div class="form-label">
              <label>利率类型</label>
            </div>
            <div class="input-group-addon">
              <div class="addon-item"><input type="radio" name="rateType" :value="0" v-model.number="rateType" checked="checked"><span>年利率</span></div>
              <div class="addon-item"><input type="radio" name="rateType" :value="1" :disabled="loanLifeType === 0" v-model.number="rateType"><span>月利率</span>
              </div>
              <div class="addon-item"><input type="radio" name="rateType" :value="2" :disabled="loanLifeType === 1" v-model.number="rateType"><span>日利率</span></div>
            </div>
          </div>
          <div class="rate-box">
            <div class="input-group">
              <div class="form-label">
                <label>贷款利率</label>
                <span class="required">*</span>
              </div>
              <div class="input-group-addon">
                <input type="number" class="form-control" v-model="loanRate" @change="loanRate = calcRate(loanRate)">
                <span class="help-text">%</span>
              </div>
            </div>
            <div class="input-group" v-show="isOpen">
              <div class="form-label">
                <label>服务费率</label>
              </div>
              <div class="input-group-addon">
                <input type="number" class="form-control" v-model="serviceRate" @change="serviceRate = calcRate(serviceRate)">
                <span class="help-text">%</span>
              </div>
            </div>
            <div class="input-group" v-show="isOpen">
              <div class="form-label">
                <label>其他费率</label>
              </div>
              <div class="input-group-addon">
                <input type="number" class="form-control" v-model="otherRate" @change="otherRate = calcRate(otherRate)">
                <span class="help-text">%</span>
              </div>
            </div>
            <div class="input-group-expansion iconfont" @click="isOpen = !isOpen" :class="{expansion_open: isOpen}">&#xe60d;</div>
          </div>
          <div class="input-group" v-show="loanLifeType === 0">
            <div class="form-label">
              <label>基本天数</label>
            </div>
            <div class="input-group-addon">
              <div class="addon-item"><input type="radio" name="basicDays" :value="360" v-model="basicDays" checked="checked"><span>360天</span></div>
              <div class="addon-item"><input type="radio" name="basicDays" :value="365" v-model="basicDays"><span>365天</span></div>
            </div>
          </div>
          <div class="input-group">
            <div class="form-label">
              <label class="pament-label">还款方式</label>
            </div>
            <div class="input-group-addon">
              <span class="pament-mode">到期还本付息</span>
            </div>
          </div>
          <div class="btn-group">
            <button type="submit" class="btn-submit">计算</button>
          </div>
        </form>
      </div>
      <ul class="list-group">
        <li class="list-item">
          <span>利息总额</span>
          <span class="right"><span class="decimal">{{getDecimal(totalInterest)}}</span> 元</span>
        </li>
        <li class="list-item">
          <span>还款总额</span>
          <span class="right"><span class="decimal">{{getDecimal(totalPament)}}</span> 元</span>
        </li>
        <li class="list-item" v-show="totalService != 0">
          <span>服务费用</span>
          <span class="right"><span class="decimal">{{getDecimal(totalService)}}</span> 元</span>
        </li>
        <li class="list-item" v-show="totalOther != 0">
          <span>其他费用</span>
          <span class="right"><span class="decimal">{{getDecimal(totalOther)}}</span> 元</span>
        </li>
      </ul>
      <div class="instructions">
        <h3>使用说明</h3>
        <p>本计算器分别以年利率或日利率（月利率）为基数进行计算以下举例均按基本天数360天为例。</p>
        <p>如按年利率计算：利息=贷款金额*年利率*期限/360</p>
        <p>按日利率计算：利息=贷款金额*日利率*期限</p>
        <p>以年利7%为例，日利率=7%/360=0.0195%，</p>
        <p>月利率=7%/12=0.5834%</p>
        <p>利息的计算结果保留至小数点后两位，小数点后第三位开始舍去。</p>
        <p>计算结果仅供参考。</p>
      </div>
    </div>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import DatePicker from 'components/picker/date'
  import Vue from 'vue'
  export default {
    data () {
      return {
        amount: 0, // 贷款金额
        loanLife: 0, // 贷款期限
        loanLifeType: 0, // 贷款期限类型 0:按日计算；1:按月计算
        startDay: '', // 起息日
        endDay: '', // 到期日
        rateType: 0, // 利率类型 0:年利率；1:月利率； 2:日利率
        loanRate: 0, // 贷款利率
        serviceRate: 0, // 服务费率
        otherRate: 0, // 其他费率
        basicDays: 360, // 基本天数
        paymentType: 0, // 还款方式
        totalInterest: 0, // 利息总额
        totalPament: 0, // 还款总额
        totalService: 0, // 服务费用
        totalOther: 0, // 其他费用
        isOpen: false,
        isShowStartDate: false,
        isShowEndDate: false
      }
    },
    components: {
      Navbar,
      DatePicker
    },
    watch: {
      loanLife () {
        if (isNaN(this.loanLife)) {
          this.loanLife = 0
        }
      },
      loanLifeType () {
        this.loanLife = 0
        this.startDay = ''
        this.endDay = ''
        // 设置利率利率类型
        if (this.rateType === 0) {
          return
        }
        this.loanLifeType === 0 ? this.rateType = 2 : this.rateType = 1
      }
    },
    created () {
      this.amount = this.number2currency(this.amount)
//      this.loanRate = this.number2currency(this.loanRate, 4)
//      this.serviceRate = this.number2currency(this.serviceRate, 4)
//      this.otherRate = this.number2currency(this.otherRate, 4)
    },
    mounted () {
      this.loanLifeInp = this.$refs.loanLifeInp
    },
    methods: {
      dateStrFormat (dateStr) {
        return dateStr.split('-').map((v) => {
          return parseInt(v)
        })
      },
      dateFormate (date) {
        return date.getFullYear() + '-' + this.addZero(date.getMonth() + 1) + '-' + this.addZero(date.getDate())
      },
      addZero (num) {
        return num < 10 ? '0' + num : '' + num
      },
      currency2number (currency) {
        return Vue.filter('unformat')(currency + '')
      },
      number2currency (number, length = 2, prefix = '') {
        return Vue.filter('currency')(number, prefix, length)
      },
      toFixed (number, length = 2) {
        number = number.toFixed(length + 1)
        Math.ceil(number)
        return Vue.filter('tofixed')(number, length)
      },
      calc () {
        if (this.validate()) {
          this.totalInterest = this.calcInterest(this.loanRate)
          this.calcTotalPament()
          this.totalService = this.calcInterest(this.serviceRate)
          this.totalOther = this.calcInterest(this.otherRate)
        }
      },
      validate () {
        if (this.currency2number(this.amount) <= 0) {
          this.$dialog('请输入贷款金额')
          return false
        }
        if (this.loanLife === 0) {
          this.$dialog('请输入贷款期限')
          return false
        }
        if (this.currency2number(this.loanRate) <= 0) {
          this.$dialog('贷款利率必须大于0')
          return false
        }
        return true
      },
      calcRate (rate) {
        rate = Number(rate)
        // 先保存整数部分
        let integer = parseInt(rate)
        let decimal = (rate - integer).toFixed(7)
        let index = decimal.indexOf('.')
        if (index !== -1) {
          decimal = decimal.substr(2) * 0.1
          decimal = Math.ceil(decimal) * Math.pow(10, -6)
        }
        return +(integer + decimal).toFixed(6)
      },
      calcInterest (rate) {
        // 以年利7%为例，日利率=7%/360=0.0195%，
        // 月利率=7%/12=0.5834%
        // 利息的计算结果保留至小数点后两位，小数点后第三位向上进位。
        let amount = this.currency2number(this.amount)
        rate = rate / 100
        let total = 0
        if (this.rateType === 0) { // 年利计算
          // 按年利率计算：贷款金额*年化利率*借款期限（天/月）/360（12）=利息（保留小数点后两位，小数点后第3位开始舍去）；
          if (this.loanLifeType === 0) {
            total = amount * this.loanLife * this.calcRate(rate / this.basicDays)
          } else {
            total = amount * this.loanLife * this.calcRate(rate / 12)
          }
        } else if (this.rateType === 1) { // 月利计算
          // 按月利率计算：贷款金额*月利率*借款月数=利息（保留小数点后两位，小数点后第3位开始舍去）；
          total = this.toFixed(amount * rate * this.loanLife, 3)
        } else { // 日利计算
          // 按日利率计算：贷款金额*日利率*借款天数=利息（保留小数点后两位，小数点后第3位开始舍去）；
          total = this.toFixed(amount * rate * this.loanLife, 3)
        }
        return Number(total)
      },
      getDecimal (money) {
        let str = money.toFixed(3)
        return str.substr(0, str.length - 1)
      },
      calcTotalPament () { // 计算还款总额
        // 还款总额 = 贷款金额+利息总额
        this.totalPament = this.currency2number(this.amount) + this.currency2number(this.totalInterest)
      },
      showStartDatePicker () {
        if (this.isShowEndDate) {
          this.isShowEndDate = false
        }
        this.isShowStartDate = !this.isShowStartDate
      },
      showEndDatePicker () {
        if (this.isShowStartDate) {
          this.isShowStartDate = false
        }
        this.isShowEndDate = !this.isShowEndDate
      },
      setLoanLife () {
        this.loanLifeInp.value = parseInt(this.loanLifeInp.value)
        this.loanLife = parseInt(this.loanLifeInp.value)
        if (!this.startDay && !this.endDay) {
          return
        } else if (!this.startDay && this.endDay) { // 起息日为空
          this.startDay = this.calcStartDay()
        } else if (this.startDay && !this.endDay) { // 到期日为空
          this.endDay = this.calcEndDay()
        } else { // 起息日,到期日都不为空，计算到期日
          this.endDay = this.calcEndDay()
        }
      },
      setStartDay (year, month, date) {
        this.isShowStartDate = false
        this.startDay = year + '-' + month + '-' + date
        if (!this.loanLife && !this.endDay) {
          return
        } else if (!this.loanLife && this.endDay) { // 贷款期限为空
          this.loanLife = this.calcLoanLife()
        } else if (this.loanLife && !this.endDay) { // 到期日为空
          this.endDay = this.calcEndDay()
        } else { // 贷款期限,到期日都不为空，计算到期日
          this.endDay = this.calcEndDay()
        }
      },
      setEndDay (year, month, date) {
        this.isShowEndDate = false
        this.endDay = year + '-' + month + '-' + date
        if (!this.startDay && !this.loanLife) {
          return
        } else if (!this.startDay && this.loanLife) { // 起息日为空
          this.startDay = this.calcStartDay()
        } else if (this.startDay && !this.loanLife) { // 贷款期限为空
          this.loanLife = this.calcLoanLife()
        } else { // 贷款期限,起息日都不为空，计算起息日
          this.startDay = this.calcStartDay()
        }
      },
      calcLoanLife () {
        if (this.loanLifeType === 0) {
          // 按天机算
          let rangeTime = new Date(this.endDay) - new Date(this.startDay)
          this.loanLife = Math.floor(rangeTime / 1000 / 3600 / 24)
          if (this.loanLife < 0) {
            this.$dialog('到期日不能小于起息日')
            this.loanLife = 0
            this.startDay = ''
            this.endDay = ''
          } else if (this.loanLife === 0) {
            this.$dialog('贷款期限最低为1天')
            this.loanLife = 0
            this.startDay = ''
            this.endDay = ''
          }
        } else {
          // 按月计算，只有贷款期限为空或者为0才会计算到这里
          let dateArr1 = this.dateStrFormat(this.startDay)
          let dateArr2 = this.dateStrFormat(this.endDay)
          this.loanLife = dateArr2[1] - dateArr1[1]
          if (this.loanLife === 0) {
            this.loanLife = 1
            let year = dateArr1[0]
            let month = parseInt(dateArr1[1]) + 1
            if (month > 12) {
              year++
              month = month % 12
            }
            let day = dateArr1[2]
            let date = new Date(year + '-' + this.addZero(month) + '-' + this.addZero(day))
            this.endDay = this.dateFormate(date)
          }
        }
        return this.loanLife
      },
      calcStartDay () {
        if (this.loanLifeType === 0) {
          // 按天机算
          let date = new Date(new Date(this.endDay).getTime() - this.loanLife * 24 * 60 * 60 * 1000)
          this.startDay = this.dateFormate(date)
        } else {
          // 按月计算
          let dateArr = this.dateStrFormat(this.endDay)
          let year = Math.floor((dateArr[0] * 12 + dateArr[1] - this.loanLife) / 12)
          let month = (dateArr[0] * 12 + dateArr[1] - this.loanLife) % 12
          if (month === 0) {
            month = 12
          }
          let date = new Date(year + '-' + this.addZero(month) + '-' + this.addZero(dateArr[2]))
          this.startDay = this.dateFormate(date)
        }
        return this.startDay
      },
      calcEndDay () {
        if (this.loanLifeType === 0) {
          // 按天机算
          let date = new Date(new Date(this.startDay).getTime() + this.loanLife * 24 * 60 * 60 * 1000)
          this.endDay = this.dateFormate(date)
        } else {
          // 按月计算
          let dateArr = this.dateStrFormat(this.startDay)
          let year = dateArr[0] + Math.floor((this.loanLife + dateArr[1]) / 12)
          let month = (dateArr[1] + this.loanLife) % 12
          let date = new Date(year + '-' + this.addZero(month) + '-' + this.addZero(dateArr[2]))
          this.endDay = this.dateFormate(date)
        }
        return this.endDay
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'
  .page-content
    overflow scroll

  ul, li
    margin 0
    padding 0
    list-style-type none

  select
    appearance none
    -webkit-appearance none
  ::-webkit-input-placeholder { /* WebKit browsers */
    color rgba(255, 255, 255, 0.6)
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color rgba(255, 255, 255, 0.6)
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color rgba(255, 255, 255, 0.6)
  }
  :-ms-input-placeholder { /* Internet Explorer 10+ */
    color rgba(255, 255, 255, 0.6)
  }
  input
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  input::-webkit-outer-spin-button, input::-webkit-inner-spin-button
    -webkit-appearance none !important
    -moz-appearance textfield
    margin: 0
  .container
    padding-bottom 1px
    color #fff
    background-color #275482

  form
    width 100%
    padding 1px 0
  .rate-box
    position relative
    overflow hidden
    background-color #22466B
    .input-group-expansion
      width px2rem(54px)
      height px2rem(54px)
      line-height px2rem(54px)
      font-size px2rem(54px)
      right px2rem(50px)
      top px2rem(32px)
      margin-left px2rem(20px)
      position absolute
      color rgba(255, 255, 255, 0.8)
      &.expansion_open
        transform rotate(180deg)
        -webkit-transform rotate(180deg)
    .input-group
      padding-right px2rem(124px)
      .input-group-addon
        width px2rem(408px)
  .input-group
    display table
    width 100%
    padding 0 px2rem(50px)
    margin px2rem(20px) 0
    .form-label
      display table-cell
      vertical-align top
      position relative
      label
        display block
        margin 0
        padding 0
        font-size px2rem(28px)
        font-weight normal
        line-height px2rem(80px)
        white-space nowrap
        &.pament-label
          line-height px2rem(40px)
      .required
        position absolute
        color #fff
        line-height px2rem(80px)
        right px2rem(40px)
        top 0
        font-size px2rem(30px)
    .input-group-addon
      width px2rem(482px)
      position relative
      display table-cell
      vertical-align top
      .input-alias
        width 100%
        height 100%
        position absolute
        left 0
        top 0
        right 0
        bottom 0
        z-index 10
        background-color rgba(255,255,255,0)
        cursor auto
      span.pament-mode
        font-size px2rem(28px)
        line-height px2rem(40px)
      .addon-item
        float left
        padding px2rem(15px) 0
        width px2rem(132px)
        height px2rem(80px)
        position relative
        & + .addon-item
          margin-left px2rem(40px)
        span
          text-align center
          border-radius px2rem(4px)
          font-size px2rem(20px)
          display block
          width 100%
          height 100%
          line-height px2rem(48px)
          color #fff
          border 1px solid rgba(255, 255, 255, 0.5)
        input
          top px2rem(15px)
          bottom 0
          position absolute
          opacity 0
          width 100%
          height px2rem(50px)
          &:checked + span
            color #21507f
            background-color #fff
          &:disabled + span
            color #275482
            background-color #22466b
            border-color #22466b
      .loan-life
        position absolute
        top 0
        right 0
        width px2rem(168px)
        height px2rem(80px)
        border-radius px2rem(4px)
        border 1px solid rgba(255, 255, 255, 0.5)
        .loan-life-item
          float left
          width 50%
          height 100%
          position relative
          span
            text-align center
            border-radius px2rem(4px)
            font-size px2rem(28px)
            display block
            width 100%
            height 100%
            line-height px2rem(78px)
            color #fff
          input
            top 0
            bottom 0
            position absolute
            opacity 0
            width 100%
            height 100%
            &:checked + span
              color #21507f
              background-color #fff
      .form-control
        display block
        padding 0 15px
        margin 0
        width 100%
        height px2rem(80px)
        // line-height px2rem(80px)
        font-family inherit
        font-size px2rem(30px)
        color #fff
        background-color #3b6897
        border none
        border-radius px2rem(6px)
        outline none
        box-shadow none
        &.loan-life-text
          width px2rem(290px)
      .help-text
        position absolute
        top 0
        right 10px
        font-size px2rem(28px)
        line-height px2rem(80px)
      .caret
        position absolute
        top px2rem(36px)
        right px2rem(24px)
        width 0
        height 0
        border-style solid
        border-width px2rem(8px)
        border-color #fff transparent transparent transparent

  .btn-group
    margin px2rem(30px) 0 px2rem(40px)
    .btn-submit
      margin 0 auto
      display block
      width px2rem(648px)
      height px2rem(80px)
      line-height px2rem(80px)
      text-align center
      font-family inherit
      font-size px2rem(32px)
      color #fff
      letter-spacing px2rem(4)
      background #60c9c8
      border none
      border-radius px2rem(4px)
      outline none

  .list-group
    background-color #fff
    .list-item
      padding 0 px2rem(20px)
      font-size px2rem(32px)
      line-height px2rem(80px)
      color #21507f
      & + .list-item
        border-top 1px dotted #21507f
      .right
        float right

  .instructions
    padding px2rem(28px) px2rem(20px) px2rem(30px)
    h3, p
      margin 0
      padding 0
      color #21507f
    h3
      height px2rem(44px)
      line-height px2rem(28px)
      font-size px2rem(28px)
      padding-bottom px2rem(16px)
    p
      font-size px2rem(22px)
      line-height px2rem(40px)
</style>



// WEBPACK FOOTER //
// calculator-new.vue?e6fa8282